export default "__VITE_ASSET__fw8onBcA__"